import React, { useEffect, useState } from 'react';
import axios from 'axios';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useParams,useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { animationone } from '../../animations/Animation'; 
import {Helmet} from "react-helmet";
import Authuser from '../../api/Authuser'; 
import Favcoincheck from './Favcoincheck';

export default function Addfavouriteone() {
let canceltoken;
const {pairname} = useParams();
const {http,bUrl} = Authuser();
const navigate = useNavigate();
const token = localStorage.getItem('token');
const [pairtcoins,setPairCoins] = useState([]);
const [countrypair,setCountryPairs] = useState([]);
const [coinpair,setCoinPairs] = useState([]);
const [countrydetails,setCountrydetails] = useState([]); 
const [loader,setLoader] = useState('off');
const [hasMore,setHasMore] = useState(true);
const [ddata,setDdata] = useState(30);
const [query,searchQuery] = useState("");

useEffect(()=>{
    getdefaultcoins();
    getcountrypairs();
    getcoinpairs();
    getusercountrydetails();
},[]);

const getdefaultcoins = () =>{
    canceltoken = axios.CancelToken.source();
    setLoader('on');
    http.get('/fav-coin-usdt/'+pairname+'/'+ddata,{canceltoken:canceltoken.token}).then(res=>{
        setPairCoins(res.data.data);
        setLoader('off');
    });
  };

const getcountrypairs = () =>{
    canceltoken = axios.CancelToken.source();
http.get('/user-country-pair/'+token,{canceltoken:canceltoken.token}).then(res=>{
    setCountryPairs(res.data);
});
};

const getcoinpairs = () =>{
    canceltoken = axios.CancelToken.source();
    http.get('/coin-pairs',{canceltoken:canceltoken.token}).then(res=>{
        setCoinPairs(res.data);
    });
}

const pairchange = (pair_name) =>{
    navigate('/add-favourites-two/'+pair_name);
}

const getusercountrydetails = () =>{
    canceltoken = axios.CancelToken.source();
    http.get('/user-country-details/'+token,{canceltoken:canceltoken.token}).then(res=>{
        setCountrydetails(res.data);
    });
}

const fetchmoreData = ()=>{
    let mdata = ddata + 50;
    setDdata(ddata+50);
        http.get('/fav-coin-usdt/'+pairname+'/'+mdata).then(res=>{
            setPairCoins(res.data.data);
        });
}


  return (
<motion.div transition={{ type:'tween', duration:0.2 }} initial="out" animate="end" exit="out" variants={animationone} >   

<Helmet>
    <title>Maxpayz | Market</title>
    <link rel="stylesheet" href="/assets/css/market.css" />
</Helmet>    

<div className="page-content-wrapper"> 

<div className="w-100">
<div className="card" style={{background:'#05002E'}}>

<div className="card-body">
<div className="colorful-tab">
<ul className="nav mb-2 " id="affanTab3" role="tablist" style={{position:'fixed', marginTop: '-11px', background:'#05002E', width:'95%'}}>

<div className="input-group w-100">
    <button className="btn btn-dark" type="button"><i className="fa fa-search"></i></button>
    <input className="form-control form-control-clicked" onChange={(e)=>searchQuery(e.target.value)} id="txt_searchall" type="search" placeholder="Making Closer Digitally" style={{marginLeft: '-30px', height:'45px', background: '#05002D', border:'none', color:'white', borderBottom: '1px solid #0F243E', textAlign:'center'}} />
</div>

{/* <!-- Country Pair List --> */}
<center style={{marginTop:'0px'}}>
<li className="nav-item" role="presentation" style={{border:'none'}}>
<span className={`btn-pair ${countrypair.pair_name == pairname && 'active'}`} onClick={() => pairchange(countrypair.pair_name)} >
    {countrypair.pair_name}
</span>
</li>
</center>

{/* <!-- Coin Pair List --> */}
{coinpair.map((item,index)=>(
<center style={{marginTop:'0px'}} key={item.id}>
<li className="nav-item" role="presentation" style={{border:'none'}}>
<span className={`btn-pair ${item.pair_name == pairname && 'active'}`} onClick={() => pairchange(item.pair_name)} >
    {item.pair_name}
</span>
</li>
</center>
))}

</ul>


<div className="tab-content shadow-sm " id="affanTab3Content">
<div className="tab-pane fade show active" id="USDT" role="tabpanel" aria-labelledby="USDT-tab">
<InfiniteScroll
    dataLength={pairtcoins.length}
    next={fetchmoreData}
    hasMore={hasMore}  
    >
<table className="table mb-0 text-white coin_table">
    <thead style={{background:'#05002E', position:'fixed', marginTop: '58px', width:'95%', borderTop: '1px solid #0F243E'}}>
    <tr>
        <th scope="col" className="col-1"></th>
        <th scope="col" className="col-5" style={{textAlign:'center', color:'rgba(255, 255, 255, 0.5)'}}>Coin Name</th>
        <th scope="col" className="col-3" style={{textAlign:'center', color:'rgba(255, 255, 255, 0.5)'}}>Favourites</th>
    </tr>
    </thead><br/><br/><br/><br/><br/>
    {loader==='on' &&
    <tbody>
    <tr>
    <td colSpan={4} style={{background:'black'}}><center style={{marginTop:'20px'}}><span><img src="/assets/images/loading.gif" /></span></center></td>
    </tr>
    </tbody>
    }
    {loader==='off' &&
    <tbody>
    {pairtcoins.filter((item)=>item.coin_code.toLowerCase().includes(query.toLowerCase())).map((item,index)=>(  
    <tr style={{background:'#000066'}} key={item.id} >
    <td className="col-3">
    <img src={`${bUrl}storage/${item.symbol}`} style={{width:'25px', height:'25px'}} />
    </td>
    <td className="col-5" style={{textAlign:'left'}}>
        {item.coin_code} / <span style={{color:'rgba(255, 255, 255, 0.5)', fontSize:'10px'}}>{pairname}</span><br/>
        <span style={{color:'rgba(255, 255, 255, 0.5)', fontSize:'10px'}}>{item.coin_name}</span>
    </td>
    
    <Favcoincheck coin={item.coin_code} pair={pairname} />
    
    </tr>
    ))}
    </tbody>
    }
</table>
</InfiniteScroll>
</div>
</div>


</div>
</div>

</div>
</div>
</div>

</motion.div>
  )
}
